var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      height: "150",
      label: "订单"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("项目ID：" + _vm._s(scope.row.objectId))]), _c("p", [_vm._v("项目名称：" + _vm._s(scope.row.objectName))]), _c("p", [_vm._v("平台订单号：" + _vm._s(scope.row.platformOrderno))]), _c("p", [_vm._v("游戏订单号：" + _vm._s(scope.row.cpOrderno))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "订单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.finishTime ? _c("p", {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("已发货")]) : _vm._e(), !scope.row.finishTime ? _c("p", {
          staticStyle: {
            color: "gray"
          }
        }, [_vm._v("未发货")]) : _vm._e(), _c("p", [_vm._v("订单创建时间：" + _vm._s(scope.row.logTime))]), scope.row.finishTime ? _c("p", [_vm._v("订单完成时间：" + _vm._s(scope.row.finishTime))]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "消费金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("需支付金额（元）: " + _vm._s(scope.row.totalFee / 100))]), _c("p", [_vm._v("支付前货币余额：" + _vm._s(scope.row.balance))]), scope.row.coin ? _c("p", [_vm._v("本次到账货币数量：" + _vm._s(scope.row.coin))]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "服务器信息",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("服务器id：" + _vm._s(_vm.serverList[scope.row.serverId]))]), _c("a", {
          staticStyle: {
            color: "#409EFF"
          },
          attrs: {
            target: "_black",
            href: "http://ip.tool.chinaz.com/" + scope.row.ip
          }
        }, [_vm._v("ipv4：" + _vm._s(scope.row.ip))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "角色信息",
      width: "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("p", [_vm._v("openId：" + _vm._s(scope.row.openId))]), _c("a", {
          staticStyle: {
            cursor: "pointer",
            color: "#409EFF"
          },
          on: {
            click: function click($event) {
              return _vm.goRouterMsg(scope.row.roleId);
            }
          }
        }, [_vm._v("角色id：" + _vm._s(scope.row.roleId))]), _c("p", [_vm._v("角色名称：" + _vm._s(scope.row.roleName))]), _c("p", [_vm._v("角色等级：" + _vm._s(scope.row.roleLevel))]), _c("p", [_vm._v("VIP级: " + _vm._s(scope.row.roleVipLevel))])];
      }
    }])
  })], 1)], _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };